var _defs, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCharcoalGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 200",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgCharcoal",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1f1f22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3a3a40"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "gridCharcoal",
    width: 20,
    height: 20,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0 L0 0 0 20",
    fill: "none",
    stroke: "#ffffff",
    strokeOpacity: 0.06,
    strokeWidth: 1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    fill: "url(#bgCharcoal)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    fill: "url(#gridCharcoal)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharcoalGrid);
export default __webpack_public_path__ + "static/media/charcoal-grid.2ac936191c89fa073bf70092a7b5b3c7.svg";
export { ForwardRef as ReactComponent };